import { __decorate, __metadata } from "tslib";
// NPM
import _ from "lodash";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let TimeLine = /** @class */ (() => {
    let TimeLine = class TimeLine extends Vue {
        constructor() {
            super(...arguments);
            this.interval = 0;
            this.colors = ["#556EE6", "#34C38F", "#F1B44C", "#495057", "#008080", "#E83E8C", "#6F42C1", "#F1734F", "#576490", "#50A5F1"];
            this.lastMinuteOfTheDay = 1440;
            this.tenThirtyPM = 1350;
            this.startingHourNumber = 9; // CW-TL-AX-001
            this.timelineWidthInMinutes = 12 * 60; // CW-TL-AX-002
            this.hoursCount = this.timelineWidthInMinutes / 60;
            this.timeLineBeginingInMinutes = this.startingHourNumber * 60; // CW-TL-AX-001
            this.timelineWidthinPixels = 0;
            this.singleMinuteWidth = 0;
            this.loaded = false;
        }
        handleResize() {
            this.recalcWidths();
            ClockWorkModule.touchEntries();
        }
        async recalcTimeline() {
            // Set the starting hour number to 9 and the timeline width in minutes to 12 hours
            this.startingHourNumber = 9;
            this.timelineWidthInMinutes = 12 * 60;
            // This function returns the number of minutes to be added to the timeline if the ending time goes beyond the current timeline
            function getToBeAddedMinutesValue(cutOver) {
                // Define an array of ranges and their corresponding values
                const ranges = [30, 90, 150, 210, 270, 330, 390, 450, 510, 570, 630, 690, 720];
                const values = [60, 120, 180, 240, 300, 360, 420, 480, 540, 600, 660, 720, 780];
                // Loop through the ranges and return the corresponding value for the first range that the cutOver time is less than
                for (let i = 0; i < ranges.length; i++) {
                    if (cutOver < ranges[i]) {
                        return values[i];
                    }
                }
                // If the cutOver time is greater than or equal to the last range, return the value corresponding to the last range
                return values[values.length - 1];
            }
            // If there are entries
            if (this.entries.length > 0) {
                // Sort the entries by start time
                var sortedEntries = _.sortBy(this.entries, (x) => x.startTime);
                // Calculate the starting and ending minute for the timeline based on the first and last entries
                var firstEntryStartingMinute = Math.round(sortedEntries[0].timeSinceMidNightInMinutes);
                var lastEntryEndingMinute = Math.round(sortedEntries[sortedEntries.length - 1].timeSinceMidNightInMinutes + sortedEntries[sortedEntries.length - 1].totalTimeInSeconds / 60);
                // If the first entries' starting minute is greater than 12:00 PM
                if (firstEntryStartingMinute > 12 * 60) {
                    // CW-TL-AX-004
                    // Set the starting hour number to 12, the timeline width in minutes to 12 hours:
                    this.startingHourNumber = 12;
                    this.timelineWidthInMinutes = 12 * 60;
                }
                else {
                    // Set the starting hour number based on the starting minute
                    this.startingHourNumber =
                        firstEntryStartingMinute < 90
                            ? 0
                            : (firstEntryStartingMinute % 60 > 30 ? firstEntryStartingMinute - (firstEntryStartingMinute % 60) : firstEntryStartingMinute - (firstEntryStartingMinute % 60) - 60) / 60;
                    // To begin with, set the timeline width in minutes to 12 hours:
                    this.timelineWidthInMinutes = 12 * 60;
                    // Calculate the present timeline ending minute
                    var presentTimeLineEndingMinute = this.startingHourNumber * 60 + this.timelineWidthInMinutes;
                    // Calculate the new timeline width in minutes based on the last entries' ending minute and the present timeline ending minute.
                    this.timelineWidthInMinutes =
                        lastEntryEndingMinute > this.tenThirtyPM
                            ? this.lastMinuteOfTheDay - this.startingHourNumber * 60
                            : presentTimeLineEndingMinute > lastEntryEndingMinute
                                ? presentTimeLineEndingMinute - lastEntryEndingMinute > 30
                                    ? this.timelineWidthInMinutes
                                    : this.timelineWidthInMinutes + 60
                                : lastEntryEndingMinute - presentTimeLineEndingMinute < 30
                                    ? this.timelineWidthInMinutes + 60
                                    : this.timelineWidthInMinutes + getToBeAddedMinutesValue(lastEntryEndingMinute - presentTimeLineEndingMinute);
                }
                this.hoursCount = this.timelineWidthInMinutes / 60;
                this.timeLineBeginingInMinutes = this.startingHourNumber * 60;
            }
            this.recalcWidths();
        }
        async recalcWidths() {
            if (this.loaded) {
                this.timelineWidthinPixels = document.getElementById("timelineUnique").clientWidth;
                this.singleMinuteWidth = this.timelineWidthinPixels / this.timelineWidthInMinutes;
            }
        }
        fixDisplayEntryPositions(entry) {
            if (!this.loaded) {
                return "";
            }
            var index = this.orderedEntries.indexOf(entry);
            if (index > 9) {
                index = index % 10;
            }
            var entryWidthInPixels = this.singleMinuteWidth * (entry.totalTimeInSeconds / 60);
            var leftPositionInPixels = this.singleMinuteWidth * (entry.timeSinceMidNightInMinutes - this.timeLineBeginingInMinutes);
            return "left: " + leftPositionInPixels + "px; width:" + entryWidthInPixels + "px;" + " background-color:" + this.colors[index];
        }
        hourSpacer(n) {
            if (!this.loaded) {
                return;
            }
            return this.singleMinuteWidth * 60 * (n - 1);
        }
        // public hourMarker(n: number): string {
        // 	var time = n - 1 + this.startingHourNumber;
        // 	return time == 0 ? " 12 am" : time > 11 ? (time == 24 ? " 12am" : time == 12 ? "12 pm" : time - 12 + " pm") : time + " am";
        // }
        hourMarker(n) {
            const time = n + this.startingHourNumber - 1;
            const hour = time % 12 === 0 ? 12 : time % 12;
            const period = time < 12 || time === 24 ? "am" : "pm";
            return `${hour} ${period}`;
        }
        shouldShowMarker(n) {
            // var marker = (n - 1) % 3 == 0;
            // return this.timelineWidthinPixels > 500 || marker;
            return true;
        }
        isLiveEntry(entry) {
            return entry.endTime == null ? "live-firing-entry" : "";
        }
        entriesWatcher(newval, oldval) {
            this.recalcTimeline();
        }
        isRunningWatcher(newVal) {
            if (newVal) {
                this.setupInterval();
            }
            else if (this.interval) {
                clearInterval(this.interval);
            }
        }
        setupInterval() {
            this.recalcWidths();
            this.interval = window.setInterval(() => {
                this.updateRunningEntry();
            }, 1000);
        }
        updateRunningEntry() {
            if (!this.isRunning) {
                return;
            }
            const istOffset = 5 * 60 + 30; // IST offset in minutes
            this.entries.forEach((entry) => {
                if (!entry.endTime) {
                    const endTimeInSeconds = Date.now();
                    const startTimeInSeconds = new Date(entry.startTime).getTime() + istOffset * 60 * 1000;
                    entry.totalTimeInSeconds = (endTimeInSeconds - startTimeInSeconds) / 1000;
                }
            });
        }
        get orderedEntries() {
            return _.orderBy(this.entries, "startTime");
        }
        mounted() {
            this.loaded = true;
        }
        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], TimeLine.prototype, "entries", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], TimeLine.prototype, "pauseDisplay", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], TimeLine.prototype, "isRunning", void 0);
    __decorate([
        Watch("entries"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], TimeLine.prototype, "entriesWatcher", null);
    __decorate([
        Watch("isRunning"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TimeLine.prototype, "isRunningWatcher", null);
    TimeLine = __decorate([
        Component({
            name: "TimeLine",
        })
    ], TimeLine);
    return TimeLine;
})();
export default TimeLine;
